<template>
  <div class="animated fadeIn">
    <div class="row mb-20" v-cloak>
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-15">
          <div class="font-bold">PT Planner</div>
          <button v-if="getRoleId == 17 || getRoleId == 1" @click="openBlockByClubManagerModal()" class="btn-primary">
            <i class="fas fa-plus mr-5"></i>Add
          </button>
        </div>

        <b-modal modal-class="modal-custom-image" size="md" hide-footer lazy :ref="'blockByClubManager'" centered
          title="Add Block by Club Manager">
          <div class="p-5">
            <form @submit.prevent="submitBlockByClubManager">
              <b-row class="mb-20">
                <b-col sm="4">
                  <label>Date Range</label>
                </b-col>
                <b-col sm="8">
                  <flat-pickr :config="blockByClubManagerDateConfig" class="form-control"
                    v-model="blockByClubManagerForm.date_range"></flat-pickr>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <label>Time</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select class="form-control" v-model="blockByClubManagerForm.pt_planner_time_id">
                    <option :value="null">Please select</option>
                    <option v-for="time in itemTime.filter((t) => t.id != 17)" :key="time.id" :value="time.id">
                      {{ cutTime(time.time_start) }} - {{ cutTime(time.time_end) }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="4">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="8">
                  <b-form-checkbox v-model="blockByClubManagerForm.all_pt" class="mb-10">
                    ALL PT
                  </b-form-checkbox>
                  <b-form-checkbox-group v-if="!blockByClubManagerForm.all_pt" stacked
                    v-model="blockByClubManagerForm.pt_ids"
                    :options="itemsPT.map((pt) => ({ value: pt.id, text: pt.name }))" />
                </b-col>
              </b-row>
              <div class="text-right">
                <button :disabled="savingBlockByClubManager" type="submit" class="btn-primary">Add</button>
              </div>
            </form>
          </div>
        </b-modal>

        <div class="box-mini p-15 pt-20 pb-20 mb-15">
          <div class="row">
            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter by Month</div>
                </div>
                <div class="col-sm-9">
                  <input type="month" class="form-control" name="event_date" min="2000-01" v-model="dateTodayData"
                    @change="changeDate" />
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter Branch</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="branch" v-model="branch_id" @change="changeBranch" class="form-control">
                    <option :value="null" v-if="getRoleId != 7">
                      Please select
                    </option>
                    <option :value="null" v-if="getParadigmId == '1011928'">
                      Please select
                    </option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="getRoleId == 3 ||
              getRoleId == 4 ||
              getRoleId == 13 ||
              getRoleId == 17 ||
              getRoleId == 18 ||
              getRoleMappingId.includes(22) ||
              getRoleMappingId.includes(31) ||
              getRoleId == 27 ||
              getRoleId == 6 ||
              getRoleId == 20 ||
              getRoleId == 8 ||
              getRoleId == 33
            ">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Personal Trainer</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="personal_trainer" @change="changePt" v-model="pt_id" class="form-control">
                    <option :value="null" selected v-if="getRoleId != 7">
                      Please select
                    </option>
                    <option :value="null" selected v-if="getParadigmId == '1011928'">
                      Please select
                    </option>
                    <option v-for="(item, index) in itemsPT" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>

            <!-- open for specifi user crm only -->
            <div class="col-md-4" v-if="getRoleId == 7 || getRoleId == 35 || getRoleId == 34">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Personal Trainer</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select name="personal_trainer" @change="changePt" v-model="pt_id" class="form-control">
                    <option :value="null" selected>
                      Please select
                    </option>
                    <option v-for="(item, index) in itemsPT" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <!-- end open for specifi user -->
          </div>
        </div>

        <!-- DETAIL TABLE -->
        <div class="box-mini mb-15">
          <div class="section-tooltip">
            <b-tooltip target="info-pt-1" placement="bottom">
              Total All Member that Owned By PT.
            </b-tooltip>
            <b-tooltip target="info-pt-2" placement="bottom">
              Member that using PT session more than 1 times.
            </b-tooltip>
            <b-tooltip target="info-pt-3" placement="bottom">
              Member that will be expired in less than 30 days.
            </b-tooltip>
            <b-tooltip target="info-pt-4" placement="bottom">
              Total member past last month
            </b-tooltip>
          </div>
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th style="color: white;">
                    TOTAL MEMBER
                    <a class="ml-10" id="info-pt-1">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                  <th style="color: white;">
                    TOTAL ACTIVE MEMBER
                    <a class="ml-10" id="info-pt-2">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                  <th style="color: white;">
                    TOTAL MEMBER PACKAGE
                    <a class="ml-10" id="info-pt-3">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                  <th style="color: white;">
                    TOTAL MEMBER EXPIRING
                    <a class="ml-10" id="info-pt-3">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                  <th style="color: white;">
                    TOTAL MEMBER EXPIRED
                    <a class="ml-10" id="info-pt-3">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                  <th style="color: white;">
                    MEMBER PAST
                    <a class="ml-10" id="info-pt-4">
                      <i class="fas fa-exclamation-circle color-primary"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody class="font-600 box-ptPlanner">
                <tr>
                  <td class="custom-part-td">
                    <button @click="openTotalMemberModal()" class="btn-box-ptplanner">
                      <!-- {{ dataPlannerMember1.length }} -->
                      {{ total_member == 0 ? total_member_2 : total_member }}
                    </button>
                    <!-- totalActiveMember -->
                    <b-modal modal-class="modal-custom-image" size="xl" hide-footer lazy :ref="'ptPlanner'" centered
                      title="Total Member">
                      <!-- <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white">Transaction ID</th>
                            <th style="color: white">Name</th>
                            <th style="color: white">Phone Number</th>
                            <th style="color: white">Membership Type</th>
                            <th style="color: white">PT Session</th>
                            <th style="color: white">PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(itemData1, index) in dataPlannerMember1"
                            :key="index + '1'"
                          >
                            <td>
                              {{ itemData1.member_pt_sessions[0].trx_id }}
                            </td>
                            <td>
                              {{
                                itemData1.first_name ? itemData1.first_name : ""
                              }}
                              {{ itemData1.last_name }}
                            </td>
                            <td>{{ itemData1.phone_number }}</td>
                            <td>{{ itemData1.membership_last_buy_name }}</td>
                            <td>
                              {{
                                itemData1.member_pt_sessions &&
                                itemData1.member_pt_sessions[0]
                                  ? itemData1.member_pt_sessions[0]
                                      .current_session_qty +
                                    " of " +
                                    itemData1.member_pt_sessions[0]
                                      .buy_session_qty
                                  : "-"
                              }}
                            </td>
                            <td>
                              {{
                                itemData1.member_pt_sessions &&
                                itemData1.member_pt_sessions[0]
                                  ? itemData1.member_pt_sessions[0].expired_at
                                  : "-"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table> -->
                      <div v-if="loadingTotalMember" class="text-center p-3">
                        Loading...
                      </div>
                      <div v-else class="table-responsive">
                        <table class="w-100 overflow-x">
                          <thead>
                            <tr>
                              <th style="color: white !important;">
                                Transaction ID
                              </th>
                              <th style="color: white !important;">PT Session</th>
                              <th style="color: white !important;">Name</th>
                              <th style="color: white !important;">
                                Phone Number
                              </th>
                              <th style="color: white !important;">
                                Membership Type
                              </th>
                              <th style="color: white !important;">
                                Membership Status
                              </th>
                              <th style="color: white !important;">Total Point</th>
                              <th style="color: white !important;">Advisor</th>
                              <th style="color: white !important;">Member Diary</th>
                              <th style="color: white !important;">Diary Last Update</th>
                              <th style="color: white !important;">PT Session</th>
                              <th style="color: white !important;">
                                PT Session Expired
                              </th>
                              <th style="color: white !important;">
                                Personal Training
                              </th>
                              <th style="color: white !important;">
                                Agreement
                              </th>
                              <th style="color: white !important;">
                                Last CheckIn
                              </th>
                              <th style="color: white !important;">
                                Detail
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(itemData1, index) in dataPlannerMember1" :key="index + '1'">
                              <td>{{ itemData1.trx_id }}</td>
                              <td>{{ itemData1.pt_session ? itemData1.pt_session.name : '-' }}</td>
                              <td>
                                {{ itemData1.member.first_name }}
                                {{ itemData1.member.last_name }}
                              </td>
                              <td>{{ itemData1.member.phone_number }}</td>
                              <td>
                                {{ itemData1.member.membership_last_buy_name }}
                              </td>
                              <td>
                                {{
                                  itemData1.member.membership_status == null
                                    ? "-"
                                    : itemData1.member.membership_status.name
                                }}
                              </td>
                              <td>
                                {{ itemData1.member.total_point == 0 || itemData1.member.total_point == null ? 0 : parseInt(itemData1.member.total_point).toLocaleString('id-ID', {maximumFractionDigits:2})}}
                              </td>
                              <td>
                                {{ itemData1.member.sales == null ? " - " : itemData1.member.sales.fullname }}
                              </td>
                              <td>
                                {{ itemData1.member.member_pt_diary_news ? itemData1.member.member_pt_diary_news.length
                                > 0 ? 'Yes' : 'No' : '-' }}
                              </td>
                              <td>
                                {{ itemData1.member.member_pt_diary_news ? itemData1.member.member_pt_diary_news.length
                                  > 0 ? formatingDate(itemData1.member.member_pt_diary_news[0].created_at) : '-' : '-' }}
                              </td>
                              <td>
                                {{
                                  itemData1.current_session_qty +
                                  " of " +
                                  itemData1.buy_session_qty
                                }}
                              </td>
                              <td>{{ formatingDate(itemData1.expired_at) }}</td>
                              <td>
                                {{
                                  itemData1.personal_training == null
                                    ? "-"
                                    : itemData1.personal_training.name
                                }}
                              </td>
                              <td style="padding: 5px;">
                                <template v-if="itemData1.transaction">
                                  <template v-if="itemData1.transaction.is_agree == 1">
                                    <b-badge style="margin:0;display:block;" :variant="'success'">Success</b-badge>
                                  </template>
                                  <template v-else>
                                    <b-badge style="margin:0;display:block;" :variant="'warning'">Waiting...</b-badge>
                                  </template>
                                </template>
                              </td>
                              <td>
                                <template>
                                  <template v-if="itemData1.member.member_gym_attendances != undefined">
                                    <!-- for -->
                                    <div v-for="itemData2 in itemData1.member.member_gym_attendances"
                                      :key="itemData2.member_id">
                                      {{ formatingDate(itemData2.created_at) }}
                                    </div>
                                  </template>
                                  <template v-else>
                                    -
                                  </template>
                                </template>
                                <!-- {{ itemData1.member.member_gym_attendances != undefined ? itemData1.member.member_gym_attendances[0].created_at : '-' }} -->
                              </td>
                              <td>
                                <b-button size="sm"
                                  @click="openPageNewTab('/memberData/detail?id=' + itemData1.member.id + '&id_lead=' + itemData1.member.lead.id)"
                                  class="btn-table green mr-1">
                                  <i class="far fa-eye"></i> Detail
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <button @click="showModal2('total_active_member')" class="btn-box-ptplanner">
                      {{ dataPlannerMember2.length }}
                    </button>
                    <!-- {{ ptPlannerStatistic.total_active_member }} -->
                    <b-modal modal-class="modal-custom-image" size="xl" hide-footer lazy :ref="'total_active_member'"
                      centered title="Total Active Member">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">Name</th>
                            <th style="color: white;">Email</th>
                            <th style="color: white;">Phone Number</th>
                            <th style="color: white;">Membership Type</th>
                            <th style="color: white;">PT Session</th>
                            <th style="color: white;">PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData2, index) in dataPlannerMember2" :key="index + '2'">
                            <td>
                              {{
                                itemData2.first_name ? itemData2.first_name : ""
                              }}
                              {{ itemData2.last_name }}
                            </td>
                            <td>{{ itemData2.email }}</td>
                            <td>{{ itemData2.phone_number }}</td>
                            <td>{{ itemData2.membership_last_buy_name }}</td>
                            <td>
                              {{
                                itemData2.member_pt_sessions &&
                                  itemData2.member_pt_sessions[0]
                                  ? itemData2.member_pt_sessions[0]
                                    .current_session_qty +
                                  " of " +
                                  itemData2.member_pt_sessions[0]
                                    .buy_session_qty
                              : "-"
                              }}
                            </td>
                            <td>
                              {{
                                itemData2.member_pt_sessions &&
                                  itemData2.member_pt_sessions[0]
                                  ? formatingDate(itemData2.member_pt_sessions[0].expired_at)
                                  : "-"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <button @click="showModal2('total_member_packages')" class="btn-box-ptplanner">
                      {{ member_packages.length }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="xl" hide-footer lazy :ref="'total_member_packages'"
                      centered title="Total Member Packages">
                      <table class="table border-table w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">TRX ID</th>
                            <th style="color: white;">Member ID</th>
                            <th style="color: white;">Member Name</th>
                            <th style="color: white;">Phone Number</th>
                            <th style="color: white;">Club</th>
                            <th style="color: white;">Package Name</th>
                            <th style="color: white;">PT Session</th>
                            <th style="color: white;">PT Name</th>
                            <th style="color: white;">Expired Date</th>
                            <th style="color: white;">Trx Date</th>
                            <th style="color: white;">Status</th>
                            <th style="color: white;">Agreement</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(itemx4, index) in member_packages">
                            <tr :key="index + '_3'" v-if="member_packages.length > 0">
                              <td>{{ itemx4.trx_id }}</td>
                              <td>{{ itemx4.member_id }}</td>
                              <td>{{ itemx4.member_name }}</td>
                              <td>{{ itemx4.phone_number}}</td>
                              <td>{{ itemx4.club_name }}</td>
                              <td>{{ itemx4.package_name }}</td>
                              <td>{{ itemx4.pt_session_qty }}</td>
                              <td>{{ itemx4.pt_name }}</td>
                              <td>{{ formatingDate(itemx4.expired_at) }}</td>
                              <td>{{ formatingDate(itemx4.trx_date) }}</td>
                              <td>{{ itemx4.packages_status }}</td>
                              <td style="padding: 5px;">
                                <template v-if="itemx4.is_agree == 1">
                                  <b-badge style="margin:0;display:block;" :variant="'success'">Success</b-badge>
                                </template>
                                <template v-else>
                                  <b-badge style="margin:0;display:block;" :variant="'warning'">Waiting...</b-badge>
                                </template>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <button @click="showModal2('total_member_expired')" class="btn-box-ptplanner">
                      {{ ptPlannerStatistic.total_member_expired }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="xl" hide-footer lazy :ref="'total_member_expired'"
                      centered title="Total Member Expiring">
                      <div class="table-responsive">
                        <table class="w-100">
                          <thead>
                            <tr>
                              <th style="color: white;">TRX ID</th>
                              <th style="color: white;">Name</th>
                              <th style="color: white;">Email</th>
                              <th style="color: white;">Phone Number</th>
                              <th style="color: white;">Membership Type</th>
                              <th style="color: white;">Package Name</th>
                              <th style="color: white;">Package Status</th>
                              <th style="color: white;">PT Session</th>
                              <th style="color: white;">PT Session Expired</th>
                              <th style="color: white;">PT Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="(itemData3, index) in dataPlannerMember3">
                              <tr :key="index + '3'" v-if="itemData3.current_session_qty > 0">
                                <td style="padding: 5px;">{{ itemData3.trx_id }}</td>
                                <td style="padding: 5px;">
                                  {{
                                    itemData3.member && itemData3.member.first_name
                                      ? itemData3.member.first_name +
                                      " " +
                                      itemData3.member.last_name
                                  : "-"
                                  }}
                                </td>
                                <td style="padding: 5px;">
                                  {{
                                    itemData3.member ? itemData3.member.email : "-"
                                  }}
                                </td>
                                <td style="padding: 5px;">
                                  {{
                                    itemData3.member
                                      ? itemData3.member.phone_number
                                      : "-"
                                  }}
                                </td>
                                <td style="padding: 5px;">
                                  {{
                                    itemData3.member
                                      ? itemData3.member.membership_last_buy_name
                                      : "-"
                                  }}
                                </td>
                                <td style="padding: 5px;">
                                  {{
                                    itemData3.pt_session
                                      ? itemData3.pt_session.name
                                      : "-"
                                  }}
                                </td>
                                <td style="padding: 5px;">
                                  <template v-if="itemData3.is_active == 0">
                                    <b-badge style="margin:0;display:block;" :variant="'warning'">Waiting</b-badge>
                                  </template>
                                  <template v-else-if="itemData3.is_active == 1">
                                    <b-badge style="margin:0;display:block;" :variant="'success'">Active</b-badge>
                                  </template>
                                  <template v-else>
                                    <b-badge style="margin:0;display:block;" :variant="'danger'">Expired</b-badge>
                                  </template>
                                </td>
                                <td>
                                  {{ itemData3.current_session_qty }} of
                                  {{ itemData3.buy_session_qty }}
                                </td>
                                <td style="padding: 5px;">{{ formatingDate(itemData3.expired_at) }}</td>

                                <td style="padding: 5px;">{{ itemData3.personal_training.name }}</td>
                              </tr>
                            </template>

                          </tbody>
                        </table>
                      </div>
                    </b-modal>
                  </td>
                  <!-- expired -->
                  <td class="custom-part-td">
                    <button @click="showModal2('total_member_expired_2')" class="btn-box-ptplanner">
                      {{totalMemberAlreadyExpired.filter((x) => x.current_session_qty > 0).length}}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy :ref="'total_member_expired_2'"
                      centered title="Total Member Expired">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">TRX ID</th>
                            <th style="color: white;">Name</th>
                            <th style="color: white;">Email</th>
                            <th style="color: white;">Phone Number</th>
                            <th style="color: white;">Membership Type</th>
                            <th style="color: white;">PT Session</th>
                            <th style="color: white;">PT Session Expired</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(itemData3, index) in totalMemberAlreadyExpired">
                            <tr v-if="itemData3.current_session_qty > 0" :key="index + '3'">
                              <td>{{ itemData3.trx_id }}</td>
                              <td>
                                {{
                                  itemData3.member && itemData3.member.first_name
                                    ? itemData3.member.first_name +
                                    " " +
                                    itemData3.member.last_name
                                : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  itemData3.member ? itemData3.member.email : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  itemData3.member
                                    ? itemData3.member.phone_number
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  itemData3.member
                                    ? itemData3.member.membership_last_buy_name
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{ itemData3.current_session_qty }} of
                                {{ itemData3.buy_session_qty }}
                              </td>
                              <td>{{ formatingDate(itemData3.expired_at) }}</td>
                            </tr>
                          </template>

                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td class="custom-part-td">
                    <button @click="showModal2('memberPast')" class="btn-box-ptplanner">
                      {{ past_member_data.length }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="xl" hide-footer lazy :ref="'memberPast'" centered
                      title="Total Member Past">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white !important;">
                              Transaction ID
                            </th>
                            <th style="color: white !important;">Name</th>
                            <th style="color: white !important;">
                              Phone Number
                            </th>
                            <th style="color: white !important;">
                              Membership Type
                            </th>
                            <th style="color: white !important;">
                              Membership Status
                            </th>
                            <th style="color: white !important;">PT Session</th>
                            <th style="color: white !important;">
                              PT Session Expired
                            </th>
                            <th style="color: white !important;">
                              Personal Training
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(pastMember, index) in past_member_data" :key="index + '2'">
                            <td style="padding: 5px;">{{ pastMember.trx_id }}</td>
                            <td style="padding: 5px;">
                              {{ pastMember.name }}
                            </td>
                            <td style="padding: 5px;">{{ pastMember.phone }}</td>
                            <td style="padding: 5px;">
                              {{ pastMember.membership_type }}
                            </td>
                            <td style="padding: 5px;">{{ pastMember.membership_status }}
                            </td>
                            <td style="padding: 5px;">
                              {{ pastMember.pt_session }}
                            </td>
                            <td style="padding: 5px;">{{ formatingDate(pastMember.pt_session_expired) }}</td>
                            <td style="padding: 5px;">
                              {{ pastMember.personal_training }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </b-modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box-mini mb-15">
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th></th>
                  <template v-for="(item, index) in plannerActivity">
                    <th v-if="item.name != 'MRA SHOW' && item.name != 'MRA APPOINTMENT' && item.name != 'PPC'"
                      :key="index" style="color: white;">
                      {{ item.name }}
                    </th>
                  </template>


                </tr>
              </thead>
              <tbody class="font-600">
                <tr v-if="valueActivity.length">
                  <td>TOTAL</td>
                  <!-- PHA SHOW -->
                  <td class="row-php-apointment">
                    <button @click="showModal2('detail_pha_show')" class="btn-php-apointment">
                      {{ filterActivity(1) }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy :ref="'detail_pha_show'" centered
                      title="PHA SHOW">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">Personal Trainer</th>
                            <th style="color: white;">Member</th>
                            <th style="color: white;">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1, index) in dataPlannerPHAshow" :key="index + '1'">
                            <td>{{ itemData1["personal_training.name"] }}</td>
                            <td>{{ itemData1["member.name"] }}</td>
                            <!-- <td v-if=" itemData1['member'] == null || itemData1['member'] == ' '">
                              -
                            </td>
                            <td v-if=" itemData1['member'] != null && itemData1['member'] != ' '">
                              {{ itemData1["member"] }}
                            </td> -->
                            <td>{{ formatingDateTime(itemData1["show_date"]) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <!-- PHP APOINTMENT -->
                  <td class="row-php-apointment">
                    <button @click="showModal2('detail_php_appointment')" class="btn-php-apointment">
                      <!-- {{ filterActivity(2) }} -->
                      {{ dataPlannerPHAappointment.length }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy :ref="'detail_php_appointment'"
                      centered title="PHA Appointment">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">Personal Trainer</th>
                            <th style="color: white;">Member</th>
                            <th style="color: white;">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1,
                            index) in dataPlannerPHAappointment" :key="index + '1'">
                            <td>{{ itemData1["personal_training.name"] }}</td>
                            <td v-if="itemData1['member'] == null ||
                              itemData1['member'] == ' '
                            ">
                              -
                            </td>
                            <td v-if="itemData1['member'] != null &&
                              itemData1['member'] != ' '
                            ">
                              {{ itemData1["member"] }}
                            </td>
                            <td>{{ itemData1["date"] }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <!-- <td>{{filterActivity(2)}}</td> -->
                  <!-- <td>{{ filterActivity(3) }}</td> -->
                  <!-- <td>{{ filterActivity(4) }}</td> -->
                  <!-- <td>coba</td>
                  <td>coba</td> -->
                  <td>{{ filterActivity(5) }}</td>
                  <td>{{ filterActivity(6) }}</td>
                  <td>{{ filterActivity(7) }}</td>
                  <td>{{ filterActivity(8) }}</td>
                  <td>{{ filterActivity(9) }}</td>
                  <td>{{ filterActivity(10) }}</td>
                  <td>{{ filterActivity(11) }}</td>
                  <!-- <td>{{ filterActivity(12) }}</td> -->
                  <td>{{ filterActivity(13) }}</td>
                  <td>{{ filterActivity(14) }}</td>
                  <td>{{ filterActivity(15) }}</td>
                  <td>{{ filterActivity(16) }}</td>
                  <td>{{ filterActivity(17) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="box-mini mb-15">
          <div class="p-15 table-custom-planner table-responsive">
            <table class="border-table w-100 overflow-x">
              <thead>
                <tr>
                  <th></th>
                  <template v-for="(item, index) in plannerActivity2">
                    <th v-if="item.name != 'MRA NOT SHOW' &&
                      item.name != 'PHA NOT SHOW' &&
                      item.name != 'CANCEL ON THE SPOT' &&
                      item.name != 'SESSION NOT SHOW'" :key="index" style="color: white;">
                      {{ item.name }}
                    </th>
                  </template>

                </tr>
              </thead>
              <tbody class="font-600">
                <tr v-if="valueActivity.length">
                  <td>TOTAL</td>
                  <td>{{ filterActivity(13) }}</td>
                  <td>{{ filterActivity(14) }}</td>
                  <td>{{ filterActivity(15) }}</td>
                  <td>{{ filterActivity(16) }}</td>
                  <td>{{ filterActivity(17) }}</td>
                  <!-- <td>{{ filterActivity(18) }}</td> -->
                  <!-- <td>{{ filterActivity(19) }}</td> -->
                  <!-- <td>coba</td> -->
                  <!-- <td>{{ filterActivity(20) }}</td> -->
                  <td>{{ filterActivity(21) }}</td>
                  <!-- <td>{{ filterActivity(22) }}</td> -->
                  <td>{{ filterActivity(23) }}</td>
                  <td>
                    <button @click="showModal2('detail_pt_apointment_cancel')" class="btn-pt_apointment_cancel">
                      {{ filterActivity(24) }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy :ref="'detail_pt_apointment_cancel'"
                      centered title="PT Appointment Cancel">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">Personal Trainer</th>
                            <th style="color: white;">Member</th>
                            <th style="color: white;">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1,
                            index) in dataPlannerPtAppointmentCancel" :key="index + '1'">
                            <td>{{ itemData1["personal_training.name"] }}</td>
                            <td v-if="itemData1['member'] == null ||
                              itemData1['member'] == ' '
                            ">
                              -
                            </td>
                            <td v-if="itemData1['member'] != null &&
                              itemData1['member'] != ' '
                            ">
                              {{ itemData1["member"] }}
                            </td>
                            <td>{{ itemData1["date"] }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td>
                    <button @click="showModal2('detail_pt_apointment_no_show')" class="btn-pt_apointment_cancel">
                      {{ dataPlannerPtAppointmentNoShow.length }}
                    </button>
                    <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy
                      :ref="'detail_pt_apointment_no_show'" centered title="PT Appointment NoShow">
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th style="color: white;">Personal Trainer</th>
                            <th style="color: white;">Member</th>
                            <th style="color: white;">Class</th>
                            <!-- <th style="color: white;">Time</th> -->
                            <th style="color: white;">NoShowDate</th>
                            <th style="color: white;">NoShowCount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(itemData1,
                            index) in dataPlannerPtAppointmentNoShow" :key="index + '1'">
                            <td style="padding-left: 5px;">
                              {{ itemData1["personal_trainer"] }}
                            </td>
                            <td style="padding-left: 5px;" v-if="itemData1['member'] == null ||
                              itemData1['member'] == ' '
                            ">
                              -
                            </td>
                            <td style="padding-left: 5px;" v-if="itemData1['member'] != null &&
                              itemData1['member'] != ' '
                            ">
                              {{ itemData1["member"] }}
                            </td>
                            <td style="padding-left: 5px;">
                              {{ itemData1["classes"] }}
                            </td>
                            <!-- <td style="padding-left: 5px;">
                              {{ itemData1["time_start"] }}
                            </td> -->
                            <td style="padding-left: 5px;">
                              {{
                                itemData1["noShowDate"] == null
                                  ? "-"
                                  : itemData1["noShowDate"]
                              }}
                            </td>
                            <td style="padding-left: 5px;">
                              {{
                                itemData1["noShowCount"] == null
                                  ? "-"
                                  : itemData1["noShowCount"]
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-modal>
                  </td>
                  <td>{{ filterActivity(26) }}</td>
                  <td>{{ filterActivity(27) }}</td>
                  <td>{{ filterActivity(28) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- END DETAIL TABLE -->

        <!-- WEEK FILTER -->
        <div class="col-6" style="padding: 0;">
          <div class="box-mini mb-15">
            <table>
              <tr style="text-align: center;">
                <td class="is-weeks-not-selected" v-for="we in setWeeksDefaultList" :key="we.w"
                  @click="onChangeWeeks(we.w)" :class="{
                    'is-weeks-selected': we.w == setWeeks ? true : false,
                  }">
                  Week {{ we.w }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- filter by pt_planner -->
        <div class="box-mini mb-15" v-if="current_pt_id">
          <div class="p-15 table-responsive">
            <table class="w-100 overflow-x">
              <tbody>
                <tr>
                  <td style="border: none;" v-for="(itemData, index) in combineName(setWeeks)" :key="index + 'days'">
                    <table v-if="index == 0" :style="{
                      width:
                        combineName(setWeeks).length >= 3 ? '100px' : '100%',
                      'background-color': 'white',
                    }">
                      <!-- <tr>
                        <td style="padding-left: 5px;border-top: none;height: 25px;"></td>
                      </tr> -->
                      <tr>
                        <td style="padding-left: 5px;">Time</td>
                      </tr>
                      <tr v-for="rowTime in itemData.time" :class="{
                        'opacity-04': compareDate(itemData.date)
                          ? true
                          : false,
                      }" :key="rowTime.id">
                        <td v-if="rowTime.id != 17" style="padding-left: 5px;">
                          <div class="body-time row row-custom-0">
                            <span style="font-size: 12px;">
                              {{ cutTime(rowTime.time_start) }} -
                              {{ cutTime(rowTime.time_end) }}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td style="border: none;" v-for="(itemData, index) in combineName(setWeeks)" :key="index + 'daysss'">

                    <!-- Disable rows by Activity -->
                    <table v-if="blockRows2(itemData) == true" :style="{
                      width:
                        combineName(setWeeks).length >= 3 ? '240px' : '100%',
                      'background-color': 'silver',
                    }">
                      <thead>
                        <th style="
                            color: #faad1a;
                            height: 47px;
                            text-align: center;
                          ">
                          {{ getNameDay(itemData.date) }},
                          {{ getDay(itemData.date) }}
                          {{ getMonth(itemData.date) }}
                        </th>
                      </thead>
                      <!-- <tr v-for="rowTime in itemData.time" :key="rowTime.id">
                        <td :class="{'opacity-04' : compareDate(itemData.date) ? true : false}" >1</td>
                      </tr> -->
                      <tr>
                        <td></td>
                      </tr>
                      <template v-for="rowTime in itemData.time">
                        <tr :class="{
                          'opacity-04': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id">
                          <td v-if="rowTime.id != 17">
                            <div class="col-12 custom-manipulator col-custom-0" v-if="current_pt_id == itemData.personal_trainer_id
                            " style="padding: 0px;">
                              <div class="col-12 col-custom-0">
                                <div class="detail-data" style="float: left;">
                                  <div v-for="(rowData, index) in rowTime.activity" :key="index + 'asd'">
                                    <div class="row" v-if="rowData.length != 0">
                                      <div class="col-12" v-if="rowData.pt_planner_activity_id != 0
                                      ">
                                        <div v-if="index == 0" style="width: 100%;">
                                          <p style="
                                              margin: 0;
                                              font-size: 11px;
                                              font-weight: 400;
                                            ">
                                            {{
                                              rowData.pt_planner_activity.name
                                            }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="rowData.length != 0 &&
                                      rowData.member_id != 0 &&
                                      index == 0
                                    ">
                                      <p style="
                                          font-size: 12px;
                                          font-weight: bold;
                                          margin: 0;
                                          text-align: left;
                                        ">
                                        {{
                                          rowData.member
                                            ? rowData.member.first_name +
                                            " " +
                                            rowData.member.last_name
                                            : rowData.lead
                                        ? rowData.lead.name
                                        : ""
                                        }}
                                      </p>
                                    </div>
                                    <div v-else>
                                      <!-- Personal Trainer -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr :class="{
                          'box-off-footer': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id + 'footer'" v-if="rowTime.id == 17">
                          <td style="text-align: center;">
                            <template>
                              <a class="btn-leave off" @click="showModalDeletePtPlannerByActivity(itemData)"
                                style="color:red;">Delete</a>
                            </template>
                            <!-- <template v-else>
                              <a class="btn-leave off" style="color:silver;">Delete</a>
                            </template> -->
                            <!-- <a
                              v-if="!rowTime.activity && rowTime.id == 17"
                              class="color-primary btn-leave-edit"
                              :class="{
                                'btn-leave off':
                                  getRoleId == 3 ||
                                  getRoleId == 4 ||
                                  getRoleId == 13 ? (current_pt_id ? false : false) ? false
                                      : true
                                    : false,
                              }"
                              @click="
                                openPage(
                                  '/ptPlannerNew/editPlannerLeave?date=' +
                                    getFullDate(itemData.date) +
                                    '&planner_id=' +
                                    rowTime.pt_planner_id +
                                    '&branch_id=' +
                                    current_branch_id
                                )
                              "
                            >
                              <i class="far fa-edit mr-5"></i>
                              Action
                            </a>
                            <a
                              v-if="itemData.empty_activity_status === true"
                              @click="
                                openPage(
                                  '/ptPlannerNew/addPlannerLeave?pt_id=' +
                                    itemData.personal_trainer_id +
                                    '&date=' +
                                    getFullDate(itemData.date) +
                                    '&branch_id=' +
                                    current_branch_id
                                )
                              "
                              class="btn-leave color-primary"
                              :class="{
                                off:
                                  getRoleId == 3 ||
                                  getRoleId == 4 ||
                                  getRoleId == 13
                                    ? (current_pt_id ? false : false)
                                      ? false
                                      : true
                                    : false,
                              }"
                            >
                              <i class="far fa-plus-square mr-5"></i>
                              Action
                            </a>
                            <a
                              v-if="itemData.empty_activity_status === false"
                              class="color-primary btn-leave off"
                            >
                              <i class="fas fa-ban mr-5"></i>
                              Action
                            </a> -->
                          </td>
                        </tr>
                      </template>
                    </table>

                    <table v-else :style="{
                      width:
                        combineName(setWeeks).length >= 3 ? '240px' : '100%',
                      'background-color': 'white',
                    }">
                      <thead>
                        <th style="
                            color: #faad1a;
                            height: 47px;
                            text-align: center;
                          ">
                          {{ getNameDay(itemData.date) }},
                          {{ getDay(itemData.date) }}
                          {{ getMonth(itemData.date) }}
                        </th>
                      </thead>
                      <!-- <tr v-for="rowTime in itemData.time" :key="rowTime.id">
                        <td :class="{'opacity-04' : compareDate(itemData.date) ? true : false}" >1</td>
                      </tr> -->
                      <tr>
                        <td></td>
                      </tr>
                      <template v-for="rowTime in itemData.time">
                        <tr :class="{
                          'opacity-04': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id">
                          <td v-if="rowTime.id != 17" class="class-selected" @click="
                            showModalDetail(
                              'is_item_selected',
                              rowTime.activity,
                              itemData,
                              rowTime.id,
                              current_pt_id == itemData.personal_trainer_id,
                              current_pt_id
                            )
                            ">
                            <div class="col-12 custom-manipulator col-custom-0" v-if="current_pt_id == itemData.personal_trainer_id
                            " style="padding: 0px;">
                              <div class="col-12 col-custom-0">
                                <div class="detail-data">
                                  <div v-for="(rowData, index) in rowTime.activity" :key="index + 'asd'">
                                    <div class="row" v-if="rowData.length != 0">
                                      <div class="col-12" v-if="rowData.pt_planner_activity_id != 0
                                      ">
                                        <div v-if="index == 0" style="width: 100%;">
                                          <p style="
                                              margin: 0;
                                              font-size: 11px;
                                              font-weight: 400;
                                            ">
                                            {{
                                              rowData.pt_planner_activity.name
                                            }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="rowData.length != 0 &&
                                      rowData.member_id != 0 &&
                                      index == 0
                                    ">
                                      <p style="
                                          font-size: 12px;
                                          font-weight: bold;
                                          margin: 0;
                                        ">
                                        {{
                                          rowData.member
                                            ? rowData.member.first_name +
                                            " " +
                                            rowData.member.last_name
                                            : rowData.lead
                                        ? rowData.lead.name
                                        : ""
                                        }}
                                      </p>
                                    </div>
                                    <div v-else>
                                      <!-- Personal Trainer -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr :class="{
                          'box-off-footer': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id + 'footer'" v-if="rowTime.id == 17">
                          <td style="text-align: center;">
                            <a v-if="!rowTime.activity && rowTime.id == 17" class="color-primary btn-leave-edit" :class="{
                              'btn-leave off':
                                getRoleId == 3 ||
                                  getRoleId == 4 ||
                                  getRoleId == 13
                                  ? (current_pt_id ? false : false)
                                    ? false
                                    : true
                                  : false,
                            }" @click="
                    openPage(
                      '/ptPlannerNew/editPlannerLeave?date=' +
                      getFullDate(itemData.date) +
                      '&planner_id=' +
                      rowTime.pt_planner_id +
                      '&branch_id=' +
                      current_branch_id
                    )
                    ">
                              <i class="far fa-edit mr-5"></i>
                              Action
                            </a>
                            <a v-if="itemData.empty_activity_status === true" @click="
                              openPage(
                                '/ptPlannerNew/addPlannerLeave?pt_id=' +
                                itemData.personal_trainer_id +
                                '&date=' +
                                getFullDate(itemData.date) +
                                '&branch_id=' +
                                current_branch_id
                              )
                              " class="btn-leave color-primary" :class="{
                      off:
                        getRoleId == 3 ||
                          getRoleId == 4 ||
                          getRoleId == 13
                          ? (current_pt_id ? false : false)
                            ? false
                            : true
                          : false,
                    }">
                              <i class="far fa-plus-square mr-5"></i>
                              Action
                            </a>
                            <a v-if="itemData.empty_activity_status === false" class="color-primary btn-leave off">
                              <i class="fas fa-ban mr-5"></i>
                              Action
                            </a>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Table -->
        <div class="box-mini mb-15" v-else>
          <div class="p-15 table-responsive">
            <table class="w-100 overflow-x">
              <tbody>
                <tr v-for="(itemData, index) in combineName(setWeeks)" :key="index + 'days'">
                  <td style="
                      border: none;
                      width: 100px;
                      position: sticky;
                      left: 0;
                      background-color: white;
                      z-index: 9;
                    ">
                    <table style="
                        width: 100%;
                        border-left: 1px solid #ddd;
                        white-space: nowrap;
                        background-color: white;
                      ">
                      <thead>
                        <th style="color: #faad1a;">
                          {{ getNameDay(itemData.date) }},
                          {{ getDay(itemData.date) }}
                          {{ getMonth(itemData.date) }}
                        </th>
                      </thead>
                      <tr>
                        <td style="padding-left: 5px;">Time</td>
                      </tr>
                      <tr v-for="rowTime in itemData.time" :class="{
                        'opacity-04': compareDate(itemData.date)
                          ? true
                          : false,
                      }" :key="rowTime.id">
                        <td v-if="rowTime.id != 17" style="padding-left: 5px;">
                          <div class="body-time row row-custom-0">
                            <span style="font-size: 12px;">
                              {{ cutTime(rowTime.time_start) }} -
                              {{ cutTime(rowTime.time_end) }}
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                      </tr>
                    </table>
                  </td>
                  <td v-for="(pt, index) in itemsPT2" :key="index" style="border: none; width: 130px;">
                    <!-- <table :style="itemsPT2.length == 0 ? 'width:100%;' : 'width:100%;white-space:nowrap;'"> -->
                    <table style="width: 265px; white-space: nowrap;">
                      <th style="color: white;">
                        {{ pt.name }}
                      </th>
                      <tr>
                        <td></td>
                      </tr>
                      <template v-for="rowTime in itemData.time">
                        <tr :class="{
                          'opacity-04': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id">
                          <td v-if="rowTime.id != 17" class="class-selected detail-data-all" @click="
                            showModalDetail(
                              'is_item_selected',
                              rowTime.activity,
                              itemData,
                              rowTime.id,
                              current_pt_id == itemData.personal_trainer_id,
                              pt
                            )">
                            <!-- <div v-if="rowTime.activity.length == 0">
                             <div class="col-12 custom-manipulator col-custom-0 text-center">
                                <a
                                  :key="rowTime.id + 'addPlanner'"
                                  @click="openPage('/ptPlannerNew/add?date=' + getFullDate(itemData.date) + '&planner_time=' + rowTime.id + '&pt_id=' + pt.id + '&branch_id=' + current_branch_id)"
                                  class="mr-10 color-primary btn-add-planner">
                                  <i class="fas fa-plus"></i>
                                </a>
                              </div>
                           </div> -->

                            <div v-for="(rowData, index) in rowTime.activity" :key="index + 'xasd'"
                              class="col-12 custom-manipulator col-custom-0 text-right" @click.stop="
                                showModalDetail(
                                  'is_item_selected',
                                  rowTime.activity,
                                  itemData,
                                  rowTime.id,
                                  pt.id == rowData.personal_trainer_id,
                                  pt.id
                                )
                                ">
                              <div class="detail-data">
                                <div v-if="pt.id == rowData.personal_trainer_id &&
                                  rowData.length != 0
                                ">
                                  <div class="row" v-if="rowData.length != 0">
                                    <div class="col-12" v-if="rowData.pt_planner_activity_id != 0">
                                      <div v-if="index == 0" style="width: 100%;">
                                        <p style="
                                            margin: 0;
                                            font-size: 11px;
                                            font-weight: 400;
                                          ">
                                          {{ rowData.pt_planner_activity.name }}
                                        </p>
                                      </div>
                                      <div v-else>
                                        {{ rowData.pt_planner_activity.name }}
                                      </div>
                                      <div v-if="rowData.member">
                                        <p style="
                                            font-size: 12px;
                                            font-weight: bold;
                                            margin: 0;
                                          ">
                                          {{
                                            rowData.member
                                              ? rowData.member.first_name +
                                              " " +
                                              rowData.member.last_name
                                              : rowData.lead
                                          ? rowData.lead.name
                                          : ""
                                          }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="index == 0">
                                    <!-- <div v-if="rowData.member">
                                      <p
                                        style="
                                          font-size: 12px;
                                          font-weight: bold;
                                          margin: 0;
                                        "
                                      >
                                        {{
                                          rowData.member
                                            ? rowData.member.first_name +
                                              " " +
                                              rowData.member.last_name
                                            : rowData.lead
                                            ? rowData.lead.name
                                            : ""
                                        }}
                                      </p>
                                    </div> -->
                                  </div>
                                  <div v-else>
                                    <!-- Personal Trainer -->
                                  </div>

                                  <!-- <div v-if="rowData.length == 0">
                                        Kosong
                                      </div> -->
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr :class="{
                          'box-off-footer': compareDate(itemData.date)
                            ? true
                            : false,
                        }" :key="rowTime.id + 'footer'" v-if="rowTime.id == 17">
                          <td style="text-align: center;">
                            <a v-if="!rowTime.activity && rowTime.id == 17" class="color-primary btn-leave-edit" :class="{
                              'btn-leave off':
                                getRoleId == 3 ||
                                  getRoleId == 4 ||
                                  getRoleId == 13
                                  ? (pt_id ? false : false)
                                    ? false
                                    : true
                                  : false,
                            }" @click="
                    openPage(
                      '/ptPlannerNew/editPlannerLeave?date=' +
                      getFullDate(itemData.date) +
                      '&planner_id=' +
                      rowTime.pt_planner_id
                    )
                    ">
                              <i class="far fa-edit mr-5"></i>
                              Action
                            </a>
                            <a v-if="itemData.empty_activity_status === true" @click="
                              openPage(
                                '/ptPlannerNew/addPlannerLeave?pt_id=' +
                                itemData.personal_trainer_id +
                                '&date=' +
                                getFullDate(itemData.date)
                              )
                              " class="btn-leave color-primary" :class="{
                      off:
                        getRoleId == 3 ||
                          getRoleId == 4 ||
                          getRoleId == 13
                          ? (pt_id ? false : false)
                            ? false
                            : true
                          : false,
                    }">
                              <i class="far fa-plus-square mr-5"></i>
                              Action
                            </a>
                            <a v-if="itemData.empty_activity_status === false" class="color-primary btn-leave off">
                              <i class="fas fa-ban mr-5"></i>
                              Action
                            </a>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- End Table -->

        <!-- detail selected -->
        <b-modal modal-class="modal-custom-image" size="lg" hide-footer lazy :ref="'is_item_selected'" centered
          title="Selected">
          <div class="col-12 custom-manipulator col-custom-0 text-right" :class="{
            'box-off-footer': compareDate(
              rowSelectedData2[0] == null ? '' : rowSelectedData2[0].date
            )
              ? true
              : false,
          }">
            <a v-if="!isViewOnly" @click="
              openPage(
                '/ptPlannerNew/add?date=' +
                getFullDate(rowSelectedData2[0].date) +
                '&planner_time=' +
                rowSelectedData2[0].rowTimeId +
                '&pt_id=' +
                selectedModalPtId +
                '&branch_id=' +
                current_branch_id
              )
              " class="mr-10 color-primary btn-add-planner">
              <i class="fas fa-plus"></i>
              Add
            </a>
          </div>
          <br />
          <table class="w-100" :class="{
            'box-off-footer': compareDate(
              rowSelectedData2[0] == null ? '' : rowSelectedData2[0].date
            )
              ? true
              : false,
          }">
            <thead>
              <tr>
                <th style="color: white;">Desc</th>
                <th style="color: white;">Date</th>
                <th style="color: white;" colspan="2">Action</th>
              </tr>
            </thead>
            <tbody v-if="rowSelectedDataShowData == true">
              <tr v-for="(rowData, index) in rowSelectedData" :key="index + 'xyz'">
                <td style="padding-left: 10px;">
                  <div v-if="rowData.length != 0 && rowData.member_id != 0">
                    <p style="font-size: 12px; font-weight: bold; margin: 0;">
                      {{
                        rowData.member
                          ? rowData.member.first_name +
                          " " +
                          rowData.member.last_name
                          : rowData.lead
                            ? rowData.lead.name
                            : ""
                      }}
                    </p>
                  </div>
                  <div v-else>Personal Trainer</div>
                  <div class="row" v-if="rowData.length != 0">
                    <div class="col-12" v-if="rowData.pt_planner_activity_id != 0">
                      {{ rowData.pt_planner_activity.name }}
                    </div>
                  </div>
                </td>
                <td>
                  <!-- {{ formatingTime(`${rowData.member_classes_schedule.updated_at}`) }} -->
                  <template v-if="rowData.pt_planner_activity_id == 24">
                    {{ formatingTime(`${rowData.member_classes_schedule ? rowData.member_classes_schedule.updated_at :
                    rowData.updated_at}`) }}
                  </template>
                  <template v-else-if="rowData.pt_planner_activity_id == 5">
                    {{ rowData.running_date ? formatingTime(`${rowData.running_date}`) : '-' }}
                  </template>
                  <template v-else>
                     {{ formatingTime(`${rowData.member_classes_schedule ? rowData.member_classes_schedule.updated_at :
                    rowData.updated_at}`) }}
                  </template>
                </td>
                <td style="padding-left: 10px;">
                  <!-- disabled for PT -->
                  <a v-if="!isViewOnly" :class="{ off: true }" :key="rowData.id + 'editPlanner'" @click="
                      openPage(
                        '/ptPlannerNew/edit?planner_id=' +
                        rowData.id +
                        '&pt_id=' +
                        rowData.personal_trainer_id
                      )
                      " class="color-primary btn-edit-planner">
                      <i class="fas fa-pencil-alt"></i>
                    </a>
                </td>
                <td style="padding-left: 10px;">
                  <!-- disabled for PT -->
                  <a v-if="!isViewOnly && getRoleId != 7" :class="{ off: true }" :key="rowData.id + 'deletePlanner'"
                  @click="deletePtPlanner(rowData.id)" class="btn-edit-planner ms-3">
                      <i class='fas fa-trash-alt text-danger'></i>
                    </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="detail-data mb-8">
            <div v-for="(rowData, index) in rowSelectedData" :key="index+'asd'">
              <div v-if="rowData.length != 0 && rowData.member_id != 0">
                {{rowData.member ? rowData.member.first_name + ' ' + rowData.member.last_name: rowData.lead ? rowData.lead.name : ''}}
              </div>
              <div v-else>
                Personal Trainer
              </div>

            </div>
          </div> -->
        </b-modal>
        <!-- End Selected -->
      </div>
    </div>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.detail-data-all {
  display: block;
  height: 45px;
  max-height: 45px;
  overflow: auto;
}

table {
  width: 100%;
  font-size: 10px;
}

td {
  // outline:1px solid #ccc;
  height: 45px;
  max-height: 30px;
}

// tr:nth-child(even){background-color: #f2f2f2;}

td,
th {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  // padding: 8px;
  padding: 0;
  border-left: none;
}

th {
  background-color: #2f353a;
  padding: 5px;
}

.class-selected:hover {
  // background-color: #ffb326;
  background-color: #ffb326;
  cursor: pointer;
}

.is-weeks-not-selected {
  cursor: pointer;
}

.is-weeks-not-selected:hover {
  cursor: pointer;
  background-color: #ffb326;
  color: white;
}

.is-weeks-selected {
  background-color: #ffb326;
  cursor: pointer;
  color: white;
}
</style>

<script>
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";
import { ModelSelect } from "vue-search-select";

export default {
  name: "ptPlannerNew",
  components: {
    ModelSelect,
    "app-pagination": Pagination,
  },
  data: function () {
    return {
      past_member_date: moment(new Date()).add(-1, 'M').format("YYYY-MM"),
      past_member_data: [],
      setWeeks: 1,
      setWeeksDefaultList: [
        {
          w: 1,
        },
        {
          w: 2,
        },
        {
          w: 3,
        },
        {
          w: 4,
        },
        {
          w: 5,
        },
      ],
      showDataFilterByPtPlanner: false,
      dataBranch: [],
      rowSelectedData: [],
      rowSelectedData2: [],
      rowSelectedDataShowData: false,
      current_branch_id: null,
      member_packages: [],
      branch_id: null,
      current_pt_id: null,
      selectedModalPtId: null,
      loadingActive: false,
      isViewOnly: false,
      getRoleId: Auth.Session.get().paradigm_role,
      getParadigmId: Auth.Session.get().paradigm_id,
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      pt_id: null,
      current_pt_name: null,
      itemsPT: [],
      itemsPT2: [],
      totalActiveMember: "",
      dateTodayData: moment(new Date()).format("YYYY-MM"),
      dateTodayDataWeek: moment(new Date()).format("DD/MM/YYYY"),
      dataActivity: [],
      config: {
        altInput: true,
        altFormat: "F Y",
        dateFormat: "Y-m-d",
      },
      addPlanner: {
        personal_trainer_id: "",
        pt_planner_activity_id: null,
        date: "",
        pt_planner_time_id: 0,
        member_id: 0,
      },
      ptPlannerStatistic: {},
      dataPlannerMember1: [],
      dataPlannerMember2: [],
      dataPlannerMember3: [],
      totalMemberAlreadyExpired: [],
      dataPlannerPHAappointment: [],
      dataPlannerPHAshow: [],
      dataPlannerPtAppointmentCancel: [],
      dataPlannerPtAppointmentNoShow: [],
      planner_id: "",
      planner_leave_id: "",
      status_planner: null,
      checkData: "",
      member_name: null,
      plannerActivity: [],
      plannerActivity2: [],
      listMember: [],
      itemTime: [],
      listData: [],
      listDataLeave: [],
      listDataNew1: [],
      listDataNew2: [],
      listDataNew3: [],
      listDataNew4: [],
      listDataNew5: [],
      listData_length: null,
      optionsMember: [{ value: 0, text: "Please select" }],
      currentTotalDay: moment(new Date(), "YYYY-MM").daysInMonth(),
      currentNumberMonth: moment(new Date()).format("M"),
      currentNumberYear: moment(new Date()).format("YYYY"),
      valueActivity: [],
      total_member: 0,
      total_member_2: 0,
      loadingTotalMember: false,
      blockByClubManagerForm: {
        date_range: moment(new Date()).format("YYYY-MM-DD"),
        pt_planner_time_id: null,
        pt_ids: [],
        all_pt: false,
      },
      blockByClubManagerDateConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        minDate: "today",
      },
      savingBlockByClubManager: false,
    };
  },
  methods: {
    formatingTime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm A")
    },
    formatingDate(val) {
      return moment(val).format("DD MMMM YYYY")
    },
    openPageNewTab(path) {
      let route = this.$router.resolve({ path: path });
      window.open(route.href, '_blank');
    },
    removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    },
    formatingDateTime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm")
    },
    blockRows2(data) {
      for (let i = 0; i < data.time.length; i++) {
        if (data.time[i].activity.length != 0) {
          for (let d = 0; d < data.time[i].activity.length; d++) {
            if (
              data.time[i].activity[d].pt_planner_activity_id == 13 ||
              data.time[i].activity[d].pt_planner_activity_id == 14 ||
              data.time[i].activity[d].pt_planner_activity_id == 15 ||
              data.time[i].activity[d].pt_planner_activity_id == 16
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
    showModalDeletePtPlannerByActivity(data) {
      var activity_id = []
      for (let i = 0; i < data.time.length; i++) {
        if (data.time[i].activity.length != 0) {
          for (let d = 0; d < data.time[i].activity.length; d++) {
            if (
              data.time[i].activity[d].pt_planner_activity_id == 13 ||
              data.time[i].activity[d].pt_planner_activity_id == 14 ||
              data.time[i].activity[d].pt_planner_activity_id == 15 ||
              data.time[i].activity[d].pt_planner_activity_id == 16
            ) {
              activity_id.push(data.time[i].activity[d].id)
            }
          }
        }
      }
      console.log(activity_id)
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((v) => {
        if (v.value) {
          console.log(activity_id)
          if (activity_id.length > 0) {
            for (let b = 0; b < activity_id.length; b++) {
              axios.delete('crm/v1/pt_planner/delete/by_activity/' + activity_id[b]).then(response => {
                this.$swal('Deleted', 'You Activity successfully deleted!', 'success')
                console.log(response)
                // this.$router.go()
                this.fetchData()
              }).catch(error => {
                console.log('error', error)
              })
            }
          }
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
          return;
        }
      }).catch(() => {
        console.log('Cancelled!')
      })
    },
    compareDate(value) {
      var rowDate = moment(value).format("YYYY-MM-DD");
      var today = moment(new Date()).format("YYYY-MM-DD");
      if (rowDate < today) {
        return true;
      }
    },
    cutTime(value) {
      return value.slice(0, -3);
    },
    openBlockByClubManagerModal() {
      if (!this.current_branch_id) {
        this.$toast.success("please select branch first!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff",
        });
        return;
      }
      this.blockByClubManagerForm = {
        date_range: moment(new Date()).format("YYYY-MM-DD"),
        pt_planner_time_id: null,
        pt_ids: [],
        all_pt: false,
      };
      this.$refs.blockByClubManager.show();
    },
    submitBlockByClubManager() {
      const dates = (this.blockByClubManagerForm.date_range || "").split(" to ");
      const date_start = dates[0] || "";
      const date_end = dates[1] || date_start;

      if (
        !date_start ||
        !this.blockByClubManagerForm.pt_planner_time_id ||
        (!this.blockByClubManagerForm.all_pt && this.blockByClubManagerForm.pt_ids.length === 0)
      ) {
        this.$toast.success("please fill in required fields!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff",
        });
        return;
      }
      this.savingBlockByClubManager = true;
      axios
        .post("crm/v1/pt_planner/block_by_club_manager", {
          date_start: date_start,
          date_end: date_end,
          pt_planner_time_id: this.blockByClubManagerForm.pt_planner_time_id,
          branch_id: this.current_branch_id,
          pt_ids: this.blockByClubManagerForm.pt_ids,
          all_pt: this.blockByClubManagerForm.all_pt,
        })
        .then(() => {
          this.savingBlockByClubManager = false;
          this.$refs.blockByClubManager.hide();
          this.$toast.success("data saved successfully!", "Success", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
          });
          this.fetchData();
        })
        .catch((error) => {
          this.savingBlockByClubManager = false;
          const errMsg = error.response.data;
          this.$toast.success(errMsg.error, "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
            timeout: 5000,
          });
        });
    },
    combineName(event) {
      if (event == 1) {
        // console.log(this.listDataNew1)
        return this.listDataNew1;
      }
      if (event == 2) {
        return this.listDataNew2;
      }
      if (event == 3) {
        return this.listDataNew3;
      }
      if (event == 4) {
        return this.listDataNew4;
      }
      if (event == 5) {
        return this.listDataNew5;
      }
    },
    onChangeWeeks(ev) {
      const weekNum = Number(ev);
      this.setWeeks = weekNum;
      localStorage.setItem("ptPlannerWeeks", `${weekNum}`);
      if (!this._loadedWeeks || !this._loadedWeeks.includes(weekNum)) {
        this.loadingActive = true;
        this.fetchWeekData(weekNum).finally(() => {
          this.loadingActive = false;
        });
      }
    },
    async fetchWeekData(weekNum) {
      if (!this._weekFetchParams) return;
      const { ptId, branchId, date } = this._weekFetchParams;
      try {
        const res = await axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + ptId + '&date=' + date + '&week=' + weekNum + '&branch_id=' + branchId);
        this['listDataNew' + weekNum] = res.data;
        if (!this._loadedWeeks.includes(weekNum)) {
          this._loadedWeeks.push(weekNum);
        }
      } catch (e) {
        console.error('fetchWeekData error:', e);
      }
    },
    showModal2(id, date, pt_planner_time_id) {
      // console.log(id)
      this.$refs[id].show();
    },
    openTotalMemberModal() {
      this.$refs['ptPlanner'].show();
      this.loadingTotalMember = true;
      const branchId = this.branch_id == null ? '' : this.branch_id;
      const ptId = this._getPtId() == null ? '' : this._getPtId();
      const date = this.dateTodayData;
      axios.get('fitness/v1/personal_training/my_member?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => {
          let column = 'personal_training';
          let sort = res.data.data.rows.sort((a, b) =>
            (a[column] == null ? '' : a[column]).toString()
              .localeCompare((b[column] == null ? '' : b[column]['name']).toString())
          );
          this.dataPlannerMember1 = this.removeDuplicates(sort, 'id');
        })
        .catch((e) => console.log('error', e))
        .finally(() => { this.loadingTotalMember = false; });
    },
    deletePtPlanner(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((v) => {
        if (v.value) {
          console.log(id)
          axios.delete('crm/v1/pt_planner/' + id).then(response => {
            this.$swal('Deleted', 'You Activity successfully deleted!', 'success')
            console.log(response)
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
          return;
        }
      }).catch(() => {
        console.log('Cancelled!')
      })
    },
    showModalDetail(id, data, itemData, rowTimeID, is_showData, pt_id) {
      console.log('PT: ', pt_id)
      console.log('Data: ', data)

      this.rowSelectedData = [];
      this.rowSelectedData2 = [];
      this.rowSelectedDataShowData = is_showData;

      this.rowSelectedData = data;
      this.rowSelectedData2.push({
        date: itemData.date,
        rowTimeId: rowTimeID,
      });

      if (pt_id) {
        this.selectedModalPtId = pt_id.id == undefined ? pt_id : pt_id.id
      }

      // console.log(this.rowSelectedData)
      if (data.length > 0) {
        let payloadActivity = []
        for (let i = 0; i < data.length; i++) {
          const el = data[i];
          payloadActivity.push({
            date: el.date,
            personal_trainer_id: el.personal_trainer_id,
            member_id: el.member_id
          })
        }

        console.log('Payload Activity: ', payloadActivity)

        axios.post('crm/v1/pt_planner/multiple_activity_pt_planner_detail', {activites: payloadActivity}).then(response => {
          console.log('Response Detail: ', response.data)
          // this.rowSelectedData = response.data.data
          const resdata = response.data.data
          for (let i = 0; i < resdata.length; i++) {
            const el = resdata[i];
            Object.assign(this.rowSelectedData[i], {
              running_date: el ? el.running_date : null
            })
          }
        }).catch(error => {
          console.log('error', error)
        })
      }

      this.$refs[id].show();
    },
    filterActivity(event) {
      // if(init===1){
      //   return this.valueActivity[event-1].value
      // }else{
      //   return (this.listData.filter(item => (item.pt_planner_activity && item.pt_planner_activity.id === event) && this.toMonth(item.date) == this.currentNumberMonth)).length
      // }
      return this.valueActivity[event - 1].value;
    },

    getWeek(date) {
      var prefixes = ["1", "2", "3", "4", "5"];
      return prefixes[Math.ceil(date.getDate() / 7)];
    },
    whichWeek(value) {
      // return moment(new Date()).format('YYYY WWWW MMMM')
      var dateNew = moment(new Date(value)).format("YYYY-MM-DD");
      // var year = moment(new Date()).format('YYYY')
      // var month_number = moment(new Date()).format('M')
      let week = this.getWeek(new Date(dateNew));
      return week;
    },
    getYearMonth(value) {
      return moment(new Date(value)).format("YYYY-MM");
    },
    getFullDate(value) {
      return moment(new Date(value)).format("YYYY-MM-DD");
    },
    todayNumber() {
      return moment().isoWeekday();
    },
    getNameDay(value) {
      moment.locale("en");
      return moment(new Date(value)).format("dddd");
    },
    getDay(value) {
      moment.locale("en");
      return moment(new Date(value)).format("D");
    },
    getMonth(value) {
      return moment(new Date(value)).format("MMM");
    },
    getYear(value) {
      return moment(new Date(value)).format("YYYY");
    },
    getNumberDayInWeek(value) {
      return moment(new Date(value)).isoWeekday();
    },
    parseDateTime3(value) {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var monthName = new Date(curr.getTime());
      moment.locale("en");
      return moment(new Date(monthName)).format("MMMM YYYY");
    },
    parseImg(value) {
      return Auth.apiUrl + "crm/v1/img/banner/" + value;
    },
    getDaysInMonth(month, year) {
      var date = new Date(year + "-" + month + "-1");
      var days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },

    ifPlannerMember(event) {
      if (
        event === 1 ||
        event === 2 ||
        event === 3 ||
        event === 4 ||
        event === 5 ||
        event === 6
      ) {
        return true;
      } else {
        return false;
      }
    },
    ifTrueData(data2, data4, data5) {
      for (var i = 0; this.listData.length; i++) {
        if (
          this.whichWeek(this.listData[i].date) == data2 &&
          this.listData[i].pt_planner_time.id == data4 &&
          this.getFullDate(this.listData[i].date) == this.getFullDate(data5)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    ifTrueBtnLeave(data1, data2, data5) {
      if (
        this.whichWeek(data1) == data2 &&
        this.getFullDate(data1) == this.getFullDate(data5)
      ) {
        return true;
      } else {
        return false;
      }
    },
    ifTrueBtnLeaveEdit(data1, data2, data3, data5) {
      if (
        this.whichWeek(data1) == data2 &&
        this.getFullDate(data1) == this.getFullDate(data5) &&
        data3 == 17
      ) {
        return true;
      } else {
        return false;
      }
    },
    ifTrueCondition(data1, data2, data3, data4, data5) {
      if (
        this.whichWeek(data1) == data2 &&
        data3 == data4 &&
        this.getFullDate(data1) == this.getFullDate(data5)
      ) {
        return true;
      } else {
        return false;
      }
    },
    ifTrueCondition2(data1, data2, data3, data5) {
      if (
        this.whichWeek(data1) == data2 &&
        data3 == 17 &&
        this.getFullDate(data1) == this.getFullDate(data5)
      ) {
        return true;
      } else {
        return false;
      }
    },

    changeDate(event) {
      this.loadingActive = true;
      this.currentNumberMonth = moment(new Date(this.dateTodayData)).format(
        "M"
      );
      this.past_member_date = this.dateTodayData
      this.fetchData();
    },

    changeBranch() {
      this.current_pt_id = null;
      this.pt_id = null;
      this.loadingActive = true;
      this.current_branch_id = this.branch_id;
      this.fetchData();
    },

    changePt() {
      this.loadingActive = true;
      this.current_pt_id = this.pt_id;
      this.fetchData();
    },

    openPage(event) {
      this.$router.push(event);
    },
    refreshBranch() {
      this.loadingActive = true;
      this.current_branch_id = this.branch_id;
      this.fetchData();
    },
    _isAdminRole() {
      const session = Auth.Session.get();
      return (
        session.paradigm_role == 3 ||
        session.paradigm_role == 4 ||
        session.paradigm_role == 13 ||
        session.paradigm_role == 17 ||
        session.paradigm_role == 18 ||
        session.paradigm_role == 27 ||
        session.paradigm_role == 6 ||
        session.paradigm_role == 20 ||
        session.paradigm_role == 8 ||
        session.paradigm_role == 33 ||
        session.paradigm_role == 34 ||
        session.paradigm_role == 35 ||
        this.getRoleMappingId.includes(22) ||
        this.getRoleMappingId.includes(31)
      );
    },
    _getPtId() {
      return this._isAdminRole() ? this.pt_id : Auth.Session.get().paradigm_id;
    },
    async fetchStaticData() {
      if (this._staticLoaded) return;
      this._staticLoaded = true;
      try {
        const [times, activities] = await Promise.all([
          axios.get('crm/v1/pt_planner_time?sorting=id&sorting_type=asc'),
          axios.get('crm/v1/pt_planner_activity?sorting=id&sorting_type=asc'),
          // fitness/v1/member/data_entry — tidak dipakai di halaman ini (optionsMember tidak ada di template)
          // axios.get('fitness/v1/member/data_entry'),
        ]);
        var dataTime = [...times.data.data.rows];
        dataTime.splice(dataTime.length - 1, 1);
        this.itemTime = dataTime;
        this.dataActivity = activities.data.data.rows;
        // this.listMember = members.data.data.rows;
        // for (var i = 0; i < this.listMember.length; i++) {
        //   let memberBranchId;
        //   if (!this.listMember[i].branch_id) {
        //     memberBranchId = '(FT-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name;
        //   } else {
        //     memberBranchId = '(' + this.listMember[i].branch.codename + '-' + this.listMember[i].id + ') ' + this.listMember[i].first_name + ' ' + this.listMember[i].last_name;
        //   }
        //   this.optionsMember.push(Object.assign({}, { value: null, text: 'Please select' }, { value: this.listMember[i].id, text: memberBranchId }));
        // }
      } catch (e) {
        console.error('fetchStaticData error:', e);
        this._staticLoaded = false;
      }
    },
    async fetchData() {
      this.loadingActive = true;
      const branchId = this.branch_id == null ? '' : this.branch_id;
      const ptId = this._getPtId() == null ? '' : this._getPtId();
      const date = this.dateTodayData;
      const session = Auth.Session.get();

      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName('member_id');
        for (var i = 0; inputElements[i]; i++) {
          if (inputElements[i].className && inputElements[i].className.indexOf('disableAutoComplete') != -1) {
            inputElements[i].setAttribute('autocomplete', 'off');
          }
        }
      }

      const activeWeek = Number(this.setWeeks);
      this._weekFetchParams = { ptId, branchId, date };
      this._loadedWeeks = [];
      this.listDataNew1 = [];
      this.listDataNew2 = [];
      this.listDataNew3 = [];
      this.listDataNew4 = [];
      this.listDataNew5 = [];

      try {
        const [weekActive, activityStats, branchRes, ptRes] = await Promise.all([
          axios.get('crm/v1/pt_planner/multiple_activity_pt_planner?personal_trainer_id=' + ptId + '&date=' + date + '&week=' + activeWeek + '&branch_id=' + branchId),
          axios.get('crm/v1/pt_planner_statistic/activity?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId),
          axios.get('fitness/v1/branch/'),
          axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=' + this.current_branch_id + '&m_pt_planner=true&date=' + date),
        ]);

        this['listDataNew' + activeWeek] = weekActive.data;
        this._loadedWeeks.push(activeWeek);

        var dataKeys = Object.keys(activityStats.data);
        var dataVals = Object.values(activityStats.data);
        var arr = [];
        for (var j = 0; j < dataKeys.length; j++) {
          arr.push({ name: dataKeys[j], value: dataVals[j] });
        }
        this.valueActivity = arr;
        var actData1 = [...arr];
        var actData2 = [...arr];
        actData2.splice(0, 12);
        actData1.splice(arr.length - 9, 9);
        this.plannerActivity = actData1;
        this.plannerActivity2 = actData2;

        if (this.$router.currentRoute.fullPath != '/ptPlannerNew') {
          this.$router.replace('/ptPlannerNew');
        }
        var _branch = branchRes.data.data.rows;
        console.log('session', session.paradigm_role)
        if (Number(session.paradigm_role) == 7) {
          if (session.paradigm_id == '1011928') {
            this.dataBranch = _branch;
          } else {
            this.dataBranch = _branch.filter((item) => item.id == this.branch_id);
          }
        } else {
          this.dataBranch = _branch;
        }
        const is_pt_spv = session.paradigm_role_mapping_id;
        if (is_pt_spv.includes(22) || is_pt_spv.includes(31)) {
          this.dataBranch = _branch.filter((item) => item.id == session.paradigm_branch_id);
        }
        if (session.paradigm_id == 1061857 || session.paradigm_id == 1061825 || session.paradigm_id == 1061850 || session.paradigm_id == 1061816 || session.paradigm_id == 1061848) {
          let filter = this.dataBranch.filter((item) => item.id == Number(session.paradigm_branch_id));
          this.dataBranch = filter;
          this.branch_id = Number(session.paradigm_branch_id);
        }

        var pt = ptRes.data.data.rows;
        if (Number(session.paradigm_role)== 7) {
          if (['1011928', '1061848', '1061808', '1061829', '1061841'].includes(session.paradigm_id)) {
            this.itemsPT = pt;
            this.itemsPT2 = pt;
          } else {
            this.itemsPT = pt.filter((item) => item.id == this.pt_id);
            this.itemsPT2 = pt.filter((item) => item.id == this.pt_id);
          }
        } else {
          this.itemsPT = pt;
          this.itemsPT2 = pt;
        }
      } catch (e) {
        console.error('fetchData error:', e);
      } finally {
        this.loadingActive = false;
      }

      this._fetchSecondaryData(ptId, branchId);
    },
    _fetchSecondaryData(ptId, branchId) {
      const date = this.dateTodayData;
      const isAdmin = this._isAdminRole();

      axios.get('fitness/v1/member_pt_session/pt_planner/member/package?branch_id=' + branchId + '&personal_trainer_id=' + ptId)
        .then((res) => { this.member_packages = res.data.data; })
        .catch((e) => console.log('error', e));

      axios.get('crm/v1/pt_planner?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => {
          this.listData = res.data.data.rows;
          var newArray = [...res.data.data.rows];
          if (isAdmin) {
            this.listDataLeave = newArray.filter(function({ date }) {
              return !this[date] && (this[date] = date);
            }, {});
          } else {
            this.listDataLeave = newArray;
          }
        })
        .catch((e) => console.log('error', e));

      axios.get('crm/v1/pt_planner_statistic?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => { this.ptPlannerStatistic = res.data; })
        .catch((e) => console.log('error', e));

      axios.get('fitness/v1/personal_training/my_member_new_count?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => { this.total_member = res.data.data.total_member; })
        .catch((e) => console.log('error', e));

      axios.get('crm/v1/pt_planner_statistic/active_member?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => { this.dataPlannerMember2 = res.data.data.rows; })
        .catch((e) => console.log('error', e));

      axios.get('crm/v1/pt_planner_statistic/member_expired?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => { this.dataPlannerMember3 = res.data.data.rows; })
        .catch((e) => console.log('error', e));

      axios.get('crm/v1/pt_planner_statistic/member_already_expired?personal_trainer_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
        .then((res) => { this.totalMemberAlreadyExpired = res.data.data.rows; })
        .catch((e) => console.log('error', e));

      if (isAdmin) {
        axios.get('fitness/v1/pt_planner_member_past?date=' + this.past_member_date + '&branch_id=' + branchId + '&personal_trainer_id=' + ptId)
          .then((res) => { this.past_member_data = res.data.data.rows; })
          .catch((e) => console.log('error', e));

        axios.get('crm/v1/pt_planner/php-appointment/detail?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
          .then((res) => { this.dataPlannerPHAappointment = res.data.data.rows; })
          .catch((e) => console.log('error', e));

        axios.get('crm/v1/pt_planner/pha-show/detail?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
          .then((res) => { this.dataPlannerPHAshow = res.data.data.rows; })
          .catch((e) => console.log('error', e));

        axios.get('crm/v1/pt_planner/pt_session_appointment_cancel/detail?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
          .then((res) => { this.dataPlannerPtAppointmentCancel = res.data.data.rows; })
          .catch((e) => console.log('error', e));

        axios.get('crm/v1/pt_planner/pt_session_appointment_no_show/detail?pt_id=' + ptId + '&date=' + date + '&branch_id=' + branchId)
          .then((res) => { this.dataPlannerPtAppointmentNoShow = res.data.data; })
          .catch((e) => console.log('error', e));
      }
    },
  },
  mounted() {
    const is_pt_spv = Auth.Session.get().paradigm_role_mapping_id
    if (is_pt_spv.includes(22) || is_pt_spv.includes(31)) {
      this.branch_id = Auth.Session.get().paradigm_branch_id
      this.current_branch_id = Auth.Session.get().paradigm_branch_id
    }

    const getSessionAdd = localStorage.getItem("ptPlannerAddSession");
    if (getSessionAdd != null || getSessionAdd != undefined) {
      let _session = JSON.parse(getSessionAdd);
      if (_session.pt_id != "null") {
        this.pt_id = _session.pt_id;
        this.branch_id = _session.branch_id;
        this.dateTodayData = moment(_session.date).format("YYYY-MM");
        this.setWeeks =
          localStorage.getItem("ptPlannerWeeks") == null ||
            localStorage.getItem("ptPlannerWeeks") == undefined
            ? 1
            : localStorage.getItem("ptPlannerWeeks");
        this.changePt();
      } else {
        this.branch_id = _session.branch_id
        this.current_branch_id = _session.branch_id
      }
    }

    // Auth.Session.get().paradigm_role == 3 || // sales
    //     Auth.Session.get().paradigm_role == 4 || // sales_manager
    //     Auth.Session.get().paradigm_role == 13 || // CEO
    //     Auth.Session.get().paradigm_role == 17 || // Club Manager
    //     Auth.Session.get().paradigm_role == 18 || // Group Fitness Manager
    //     Auth.Session.get().paradigm_role == 27 || // Fitness Advisor
    //     Auth.Session.get().paradigm_role == 6 || // customer_service
    //     Auth.Session.get().paradigm_role == 20 || // Team Leader
    //      Auth.Session.get().paradigm_role == 8 || // customer_service_manager

    this.addPlanner.personal_trainer_id = Auth.Session.get().paradigm_id;
    if (
      Auth.Session.get().paradigm_role == 3 ||
      Auth.Session.get().paradigm_role == 4 ||
      Auth.Session.get().paradigm_role == 13 ||
      Auth.Session.get().paradigm_role == 17 ||
      Auth.Session.get().paradigm_role == 18 ||
      Auth.Session.get().paradigm_role == 27 ||
      Auth.Session.get().paradigm_role == 6 ||
      Auth.Session.get().paradigm_role == 20 ||
      Auth.Session.get().paradigm_role == 8 ||
      Auth.Session.get().paradigm_role == 33 ||
      this.getRoleMappingId.includes(22) ||
      this.getRoleMappingId.includes(31)
    ) {
      this.current_pt_id = this.pt_id;
    } else {
      // console.log(Auth.Session.get().paradigm_id)
      // this.current_pt_id = Auth.Session.get().paradigm_id;
      this.current_pt_id = this.pt_id;
    }

    // set access just for personal trainer
    if (Auth.Session.get().paradigm_role == 7) {
      // login kristi
      if (Auth.Session.get().paradigm_id == "1011928") {
        this.fetchStaticData();
        this.fetchData();
      } else {
        axios
          .get("fitness/v1/personal_training/" + Auth.Session.get().paradigm_id)
          .then((res) => {
            this.pt_id = res.data.data.id;
            this.current_pt_id = res.data.data.id;
            this.branch_id = res.data.data.branch_id;
            this.current_branch_id = this.branch_id;

            this.fetchStaticData();
            this.fetchData();
          });
      }
    } else {
      this.fetchStaticData();
      this.fetchData();
    }

    const roleMapping = Auth.Session.get().paradigm_role_mapping_id
    const roleId = Auth.Session.get().paradigm_role
    if (roleMapping.includes(17)) {
      this.isViewOnly = false
    } else if (Number(roleId) == 33) {
      this.isViewOnly = true
    }
  },
  destroyed() {
    // console.log(this.$route);
    if (
      this.$router.currentRoute.fullPath != "/ptPlannerNew" &&
      this.$router.currentRoute.path != "/ptPlannerNew/add"
    ) {
      localStorage.removeItem("ptPlannerWeeks");
      localStorage.removeItem("ptPlannerAddSession");
    }
  },
};
</script>
